<div style="z-index:1;position:absolute; overflow:hidden; border:1px solid; border-radius: 0.5rem; right:10px; top:10px; width:220px; height: 300px">
	<exg-map class="hideprints hidelogo" [latitude]="miniMap.latitude" [longitude]="miniMap.longitude"
	         [(zoom)]="miniMap.zoom" [maxZoom]="miniMap.maxZoom"
	         [minZoom]="miniMap.minZoom"
	         [keyboardShortcuts]="false"
	         (mapClick)="miniMap.click($event)"
	         [disableDefaultUI]="true">
		<exg-map-rectangle [north]="miniMap.rectangle.north" [south]="miniMap.rectangle.south"
		                   [west]="miniMap.rectangle.west" [east]="miniMap.rectangle.east" strokeColor="red"
		                   [strokeWeight]="1" fillColor="transparent" [clickable]="false"></exg-map-rectangle>
		<exg-map-marker [latitude]="miniMap.latitude" [longitude]="miniMap.longitude"
		                *ngIf="bigMap.zoom-miniMap.zoom > 7">
		</exg-map-marker>

	</exg-map>
</div>
<button style="z-index:1;position:absolute; bottom:0;" class="md-btn-solid"
        (click)="oeObject.showList = !oeObject.showList">
	Liste {{(!oeObject.showList)?'anzeigen':'verbergen'}}
</button>
<button style="z-index:1;position:absolute; bottom:0; left: 200px" class="md-btn-solid"
        [class.disabled]="assignList.data.length === 0"
        (click)="assignList.vorgangUMultiAssign()">
	Alle Disponieren
</button>
<ng-container >
	<div [hidden]="!oeObject.showList"
	     style="z-index:1;position:absolute; overflow:hidden; border:1px solid; border-radius: 0.5rem; bottom:40px; left:0.25rem; width:40%; height: 75%">
		<div class="content md3-surface">
			<div class="layout-auto-1 md3-card-on-surface">
				<exg-search-bar class="span-layout" [placeholder]="getRessource('SearchHeaderPlaceholder')" (Search)="Search($event)">
					<ng-template #rightTemplate>
						<app-exg-dropdown>
							<ng-template #hostTemplate>
								<i class="search-action far fa-filter"
								   [class.fas]="oeObject.uiFilterAktiv(1).length > 0"
								   [class.far]="oeObject.uiFilterAktiv(1).length === 0"></i>
							</ng-template>
							<ng-template #contentTemplate let-popup>
								<app-exg-filter #VCoeObjectFilterControl
								                (onActivateFilter)="popup.close()"
								                [MetaInfo]="oeObject.MetaInfo"
								                [visibility]="popup.visibility !== 'hidden'"
								                [showFilter]="true" [uiFilter]="oeObject.uiFilter"
								                [uiSort]="oeObject.uiSort"></app-exg-filter>
							</ng-template>
						</app-exg-dropdown>
						<app-exg-dropdown>
							<ng-template #hostTemplate>
								<i class="search-action far fa-sort-alt"
								   [class.fas]="oeObject.uiSortAktiv().length > 0"
								   [class.far]="oeObject.uiSortAktiv().length === 0"></i>
							</ng-template>
							<ng-template #contentTemplate let-popup>
								<app-exg-filter #VCoeObjectSortControl
								                (onActivateFilter)="popup.close()"
								                [MetaInfo]="oeObject.MetaInfo"
								                [visibility]="popup.visibility !== 'hidden'"
								                [showSort]="true" [uiFilter]="oeObject.uiFilter"
								                [uiSort]="oeObject.uiSort"></app-exg-filter>
							</ng-template>
						</app-exg-dropdown>
						<app-exg-dropdown>
							<ng-template #hostTemplate>
								<i class="search-action far fa-binoculars"
								   [class.fas]="oeObject.uiFilterAktiv(2).length > 0"
								   [class.far]="oeObject.uiFilterAktiv(2).length === 0"></i>
							</ng-template>
							<ng-template #contentTemplate let-popup>
								<app-exg-filter #VCoeObjectSearchControl
								                (onActivateFilter)="popup.close()"
								                [MetaInfo]="oeObject.MetaInfo"
								                [showSearch]="true" [uiFilter]="oeObject.uiFilter"
								                [visibility]="popup.visibility !== 'hidden'"
								                [uiSort]="oeObject.uiSort"></app-exg-filter>
							</ng-template>
						</app-exg-dropdown>
					</ng-template>
				</exg-search-bar>
				<div class="content">
					<exg-data-list #DLlist
					               [rowSource]="getoeList()"
					               selectKey="oeID"
					               (RowChange)="oeObject.rowChange($event)"
					               [allowSingleSelection]="true"
					               (RowDblClick)="assign($event)">
						<ng-template #rowTemplate let-OE>
							<div class="list-row-auto-1">
								<div></div>
								<div class="layout-auto-1-auto-grid-1-auto grid typo-small">
									<div class="span-2">
										<div class="grid-1-auto">
											<div>
												<strong>
													<a href="javascript:void(0)"
													   (click)="showSettings(OE);">
														{{OE.oeName}}{{(OE?.oeEName?.length > 0) ? ', ' + OE.oeEName : ''}}
													</a>
												</strong>
											</div>
											<div>
												<i class="fa-star {{(OE.starValue !== null && ((OE.starValue + 3) >= 1) )?'fas':'far'}}" ></i>
												<i class="fa-star {{(OE.starValue !== null && ((OE.starValue + 3) >= 2) )?'fas':'far'}}" ></i>
												<i class="fa-star {{(OE.starValue !== null && ((OE.starValue + 3) >= 3) )?'fas':'far'}}" ></i>
												<i class="fa-star {{(OE.starValue !== null && ((OE.starValue + 3) >= 4)  )?'fas':'far'}}" ></i>
												<i class="fa-star {{(OE.starValue !== null && ((OE.starValue + 3) == 5)  )?'fas':'far'}}" ></i>
											</div>
										</div>
									</div>
									<div class="span-2 list-secondary-text">
										<div>{{OE.adrZusatz}}</div>
										<div>{{OE.adrStr}} {{OE.adrHNum}}</div>
										<div>{{OE.adrPlz}} {{OE.adrOrt}}</div>
										<div class="typo-small" style="font-size: x-small"
										     *ngFor="let o of OE.messages">
											{{o}}
										</div>
										<div class="typo-small" style="font-size: x-small" *ngIf="OE.assignedTasksRegionsShort.length > 0">
											Aktuelle Regionen:
								      <ng-container *ngFor="let region of OE.assignedTasksRegionsShort; index as ix">
											  {{region.postCode}} ({{region.count}}){{ix !== OE.assignedTasksRegionsShort.length - 1 ? ', ' : ''}}
								      </ng-container>
										</div>
	                  <span class="typo-small spawn-reverse" style="font-size: xx-small;padding-left:0.5rem"
	                        *ngFor="let elem of OE.origins">
		                  {{elem.result.distance}} ({{elem.result.duration}})
	                  </span>
									</div>
								</div>
							</div>
						</ng-template>
					</exg-data-list>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<exg-map [latitude]="bigMap.latitude" [longitude]="bigMap.longitude" [(zoom)]="bigMap.zoom" [controlSize]="30"
       [minZoom]="bigMap.minZoom"
       (boundsChange)="bigMap.boundsChange($event)" (mapReady)="bigMap.ready($event);">
	<exg-map-type-control></exg-map-type-control>
	<exg-map-marker *ngFor="let marker of oeObject?.selected?.assignedTasks; let i = index"
	                [latitude]="marker.adrLat"
	                [longitude]="marker.adrLng"
	                [iconUrl]="markerIcon.DLassignedTask">
		<exg-map-info-window>
			<strong>{{marker.auNr}}</strong>
			<div class="typo-small">{{marker.adrStr}} {{marker.adrHNum}}</div>
			<div class="typo-small">{{marker.adrPlz}} {{marker.adrOrt}}</div>
			<div class="typo-small">{{marker.adrZusatz}}</div>
		</exg-map-info-window>
	</exg-map-marker>
	<exg-map-marker *ngFor="let oeItem of getOeListMap(); let i = index"
	                [latitude]="oeItem.adrLat"
	                [longitude]="oeItem.adrLng"
	                [iconUrl]="oeItem.marker.marker"
	                [visible]="oeItem.marker.visible">
<!-- 		[label]="{text: marker.oeName.substring(0,1), fontSize:'10px'}" -->
		<exg-map-info-window #iw [togglemode]="true" [(isOpen)]="oeItem.marker.isOpen">
			<div>
				<strong>
					<a href="javascript:void(0)"
					   (click)="showSettings(oeItem);">
						{{oeItem.oeName}}{{(oeItem?.oeEName?.length > 0) ? ', ' + oeItem.oeEName : ''}}
					</a>
					<i class="fa-star {{(oeItem.starValue !== null && ((oeItem.starValue + 3) >= 1) )?'fas':'far'}}" ></i>
					<i class="fa-star {{(oeItem.starValue !== null && ((oeItem.starValue + 3) >= 2) )?'fas':'far'}}" ></i>
					<i class="fa-star {{(oeItem.starValue !== null && ((oeItem.starValue + 3) >= 3) )?'fas':'far'}}" ></i>
					<i class="fa-star {{(oeItem.starValue !== null && ((oeItem.starValue + 3) >= 4) )?'fas':'far'}}" ></i>
					<i class="fa-star {{(oeItem.starValue !== null && ((oeItem.starValue + 3) == 5) )?'fas':'far'}}" ></i>
				</strong>
				<div class="typo-small">{{oeItem.adrStr}} {{oeItem.adrHNum}}</div>
				<div class="typo-small">{{oeItem.adrPlz}} {{oeItem.adrOrt}}</div>

				<div class="typo-small" style="font-size:x-small">{{oeItem.adrBez}}</div>
				<div class="typo-small" style="font-size:x-small" *ngFor="let o of oeItem.marker.messages">{{o}}</div>
				<div>&nbsp;</div>
				<div class="grid-1-auto">
					<div>
						<a href="javascript:void(0)" *ngIf="taskObject"
						   (click)="assignFromMap(oeItem);iw.close();">Zuweisen</a>
					</div>
					<div>
          <span class="typo-small" style="font-size: xx-small;padding-left:0.5rem"
                *ngFor="let elem of oeItem.origins">{{elem.result.distance}} ({{elem.result.duration}})
          </span>
					</div>
				</div>
			</div>
		</exg-map-info-window>
	</exg-map-marker>
	<exg-map-marker *ngIf="taskObject && taskObject.adrLat && taskObject.adrLng"
	                [latitude]="taskObject.adrLat"
	                [longitude]="taskObject.adrLng"
	                [iconUrl]="markerIcon.SO"
	                [markerClickable]="false"
	                [zIndex]="15">
		<exg-map-info-window>
			<strong>{{taskObject.auNr}}</strong>
			<div class="typo-small">{{taskObject.adrStr}} {{taskObject.adrHNum}}</div>
			<div class="typo-small">{{taskObject.adrPlz}} {{taskObject.adrOrt}}</div>
			<div class="typo-small">{{taskObject.adrZusatz}}</div>
		</exg-map-info-window>
	</exg-map-marker>
</exg-map>
